import $ from 'jquery';
import './vendor/jquery.bxslider.min.js';

console.info('[market-development.js] See? We\'ve got jQuery:', $);

$('.scroll-to').on('click', function(e){
    e.preventDefault();
    var $click = $(this);
    $('html, body').animate({
        scrollTop: $($click.attr('href')).offset().top
    }, 500);
});

$('.simple-image-slider__wrap').bxSlider({
    minSlides: 1,
    maxSlides: 1,
    hideControlOnEnd: true,
    adaptiveHeight: true,
    pager: false,
    nextText: '<i class="fa fa-angle-right" aria-hidden="true"></i>',
    prevText: '<i class="fa fa-angle-left" aria-hidden="true"></i>',
    infiniteLoop: false,
    useCSS: false
});

function showVideo($this) {
    var youtubeSlug = $this.data('youtube');
    $this.parent('.video').find('.video-embed-container iframe').attr('src', 'https://www.youtube-nocookie.com/embed/' + youtubeSlug + '?rel=0&autoplay=1&showinfo=0');
    setTimeout(function(){$this.parent('.video').find('.video-embed-container').fadeIn(400);}, 100);
}

function hideVideo($this) {
    $this.parent('.video').find('.video-embed-container').fadeOut(400, function() {
        $this.parent('.video').find('.video-embed-container iframe').attr('src', '');
    });
}

function videoSetup() {
    $('.video-link').on('click', function (e) {
        showVideo($(this));
        e.preventDefault();
        e.stopPropagation();
    });
    $(document).on('click', function() {
        $('.video-link').each(function(){
            hideVideo($(this));
        });
    });
}

function videoAspectRatio() {
    var videoWidth = $('.videos-container').width();
    var videoHeight = Math.floor(videoWidth * (9/16));
    $('.video').height(videoHeight);
    $('.video iframe').height(videoHeight);
}

 /****PAGE LOAD ACTIONS****/
videoSetup();
videoAspectRatio();
/****RESIZE ACTIONS****/
$(window).resize(function() {
    videoAspectRatio();
    stickyEvolutionColumn();
});
